import React from "react";
import AdminLayout from "../components/admin/AdminLayout";

function Settings() {
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  return (
    <AdminLayout user={user}>
      <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm">
        <h1 className="text-2xl font-bold text-slate-900">Settings</h1>
        <p className="text-slate-500 mt-2">
          This is the Settings page.
        </p>
      </div>
    </AdminLayout>
  );
}

export default Settings;